import coverImg from "assets/images/v133/cover.webp"
import titleImg from "assets/images/v133/title.webp"

export const v133Config = {
  cover: {
    en: coverImg,
  },
  title: {
    en: titleImg,
  },
}
